var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 112,
    viewBox: "0 0 458 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.2318,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.2318,
    cy: 37.6693,
    r: 1.33333,
    fill: "#FCFCFD"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.2318,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.2318,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80.2318,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.2318,
    cy: 37.6693,
    r: 1.33333,
    fill: "#5834A8"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter6_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.232,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter7_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.232,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128.232,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter9_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 140.232,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter10_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.2318,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter11_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.2318,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter12_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.2318,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter13_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.2318,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.2318,
    cy: 56.3372,
    r: 1.33333,
    fill: "#372069"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter15_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80.2318,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter16_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.2318,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter17_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.232,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.232,
    cy: 56.3372,
    r: 1.33333,
    fill: "#FCFCFD"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter19_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128.232,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter20_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.2318,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.2318,
    cy: 75.0013,
    r: 1.33333,
    fill: "#5834A8"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter22_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.2318,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter23_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.2318,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter24_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80.2318,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter25_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.2318,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.232,
    cy: 75.0013,
    r: 1.33333,
    fill: "#6F41D2",
    fillOpacity: 0.25,
    shapeRendering: "crispEdges"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter27_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.232,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter28_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128.232,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter29_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 140.232,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10061_157235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.264 20.9851C219.988 19.6221 220.265 18.3834 220.265 18.3834C220.452 17.5444 220.924 16.6366 221.866 14.8205C224.114 10.49 228 6.6421 232.434 4.57292C234.263 3.719 238.151 2.23724 243.122 2.73132C244.691 2.88754 247.904 3.24388 251.327 5.41337C252.356 6.06516 255.146 7.98412 257.212 11.6179C258.008 13.0193 260.21 17.0259 259.453 22.2657C258.871 26.2958 256.841 28.9633 255.851 30.2315C253.43 33.3313 250.64 34.8405 248.725 35.8756C247.883 36.3307 243.588 37.9642 242.427 38.3305C242.427 38.3305 242.25 38.3864 242.014 38.4907C241.449 38.7398 240.617 39.2344 240.693 39.5313C240.723 39.6496 240.888 39.702 240.986 39.7314C242.661 40.235 243.761 40.225 243.761 40.225C244.514 40.2155 244.89 40.2106 245.563 40.1182C246.219 40.0284 247.766 39.7724 250.58 38.624C251.851 38.1049 251.766 38.063 254.342 36.9426C255.161 36.5868 256.047 36.2015 256.664 35.9554C257.751 35.5217 259.907 34.7212 262.775 34.3808C263.918 34.2451 265.189 34.1028 266.872 34.301C268.664 34.5121 269.956 34.9952 270.234 35.1015C271.085 35.4269 273.189 36.2594 275.038 38.3171C275.594 38.9359 276.428 39.8832 276.985 41.3594C277.582 42.941 277.646 44.564 277.653 44.7621C277.665 45.1364 277.671 45.9719 277.786 47.1507C277.836 47.6623 277.863 47.9238 277.933 48.2048C278.057 48.7029 278.288 49.6291 279.094 50.2994C279.852 50.9302 280.714 50.9971 281.068 51.0201C282.347 51.1019 283.275 50.4975 283.63 50.2595C284.01 50.0045 284.961 49.2818 285.391 47.9642C285.7 47.019 285.592 46.2249 285.525 45.7758C285.341 44.5326 284.767 43.6906 284.444 43.227C283.647 42.0841 282.676 41.4438 282.269 41.1987C281.458 40.7111 280.795 40.5409 280.828 40.4117C280.865 40.2635 281.772 40.3323 282.482 40.4651C283.07 40.5749 284.591 40.9267 286.218 42.1595C286.874 42.656 288.83 44.1822 289.687 47.003C290.241 48.8246 290.084 50.3523 289.994 50.9657C289.617 53.5559 288.214 55.2103 287.646 55.8626C286.034 57.7132 284.205 58.4603 283.417 58.7712C281.869 59.3821 280.603 59.4839 280.294 59.5049C279.844 59.5358 278.408 59.6037 276.652 59.0777C273.899 58.2532 271.528 56.3168 270.017 53.8893C268.796 51.9264 268.37 48.0885 265.463 47.9393C262.624 47.7935 259.994 49.2793 257.89 51.0545C256.588 52.1535 255.467 53.4251 254.36 54.7157C254.197 54.9054 254.027 55.116 254.016 55.366C254.001 55.7244 254.47 56.0528 254.713 56.2439C256.075 57.3129 257.532 58.2317 258.849 59.3676C263.151 63.0773 266.423 67.8485 271.684 70.3623C274.601 71.7558 278.025 72.4594 281.1 71.1494C284.456 69.7195 286.089 66.6267 286.992 63.2679C287.586 61.059 287.725 59.3182 287.873 59.3317C287.921 59.3362 287.928 59.5249 287.993 60.0923C288.087 60.9178 288.105 60.7985 288.233 61.8002C288.382 62.963 288.477 64.0535 288.5 64.3754C288.749 67.8041 287.713 70.6199 287.713 70.6199C287.465 71.2956 286.486 73.7775 284.03 75.9705C281.454 78.2707 278.726 78.937 276.959 79.3462C273.397 80.1707 270.538 79.719 269.113 79.4795C269.113 79.4795 266.358 79.0163 262.961 77.4647C261.837 76.9511 260.664 76.1781 260.586 76.0902C260.58 76.0838 260.526 76.0194 260.506 76.0304C260.494 76.0368 260.5 76.0683 260.501 76.0773C260.537 76.2924 260.494 76.517 260.536 76.7311C260.619 77.1498 260.582 78.906 260.531 79.9416C260.507 80.4457 260.466 81.2532 260.341 82.2434C260.24 83.0444 260.028 84.6619 259.381 86.6367C259.04 87.6758 258.552 89.1326 257.489 90.83C256.294 92.7375 254.993 93.9587 254.397 94.4827C253.627 95.1595 252.076 96.497 249.643 97.3849C248.694 97.7312 247.182 98.2668 245.14 98.2054C244.468 98.1854 243.006 98.0786 241.307 97.3849C239.515 96.6532 238.362 95.6366 237.904 95.2034C237.349 94.6774 236.155 93.521 235.402 91.5906C235.153 90.9513 234.723 89.8144 234.772 88.2882C234.783 87.9324 234.867 86.1052 236.093 84.2152C237.667 81.7872 240.005 80.9827 240.677 80.7626C241.133 80.6129 241.858 80.3823 242.838 80.3823C244.466 80.3828 245.851 81.0201 245.83 81.103C245.824 81.1294 245.672 81.108 245.517 81.0955C244.416 81.0057 243.483 81.3825 243.085 81.5432C242.618 81.7318 241.541 82.1835 240.733 83.3144C240.543 83.5809 239.487 85.0597 239.903 86.9372C239.947 87.1353 240.184 88.1375 241.064 89.0288C241.218 89.1855 242.211 90.1632 243.766 90.3299C244.062 90.3619 244.512 90.4058 245.067 90.2601C246.04 90.004 246.616 89.3537 246.878 89.0493C247.161 88.7214 247.685 88.0117 247.969 86.5175C248.042 86.1337 248.354 84.3555 247.679 81.7438C247.494 81.0286 246.919 79.0288 245.417 76.8703C243.261 73.7695 240.784 72.6276 240.598 72.434C240.589 72.425 240.543 72.3746 240.508 72.3866C240.479 72.3961 240.471 72.44 240.468 72.45C240.393 72.7878 240.148 73.0678 240.045 73.3982C239.938 73.7416 239.655 74.1768 239.089 75.0472C238.762 75.5502 238.313 76.235 237.638 77.0485C236.802 78.0546 236.146 78.6191 235.306 79.3901C233.683 80.8789 232.63 81.8461 231.593 83.1028C230.948 83.8858 229.869 85.2124 228.978 87.1857C228.771 87.6464 227.88 89.6786 227.59 92.5498C227.259 95.8343 227.889 98.4928 228.364 99.9956C229.242 102.774 230.579 104.726 231.38 105.76C232.17 106.779 233.351 108.277 235.356 109.549C237.502 110.912 239.933 111.599 239.866 111.801C239.854 111.838 239.766 111.837 239.497 111.823C237.958 111.74 237.101 111.598 237.101 111.598C236.33 111.469 235.945 111.405 235.535 111.316C235.035 111.206 233.39 110.823 231.382 109.895C230.962 109.701 229.351 108.939 227.439 107.533C225.127 105.833 223.684 104.152 223.346 103.75C220.398 100.249 219.362 96.5739 218.946 95.0372C217.909 91.2033 217.774 87.2586 218.651 83.3867C219.353 80.2825 220.674 77.3619 222.191 74.5775C222.966 73.1552 223.803 71.7702 224.633 70.3793C224.998 69.7679 225.231 69.185 225.45 68.5048C225.535 68.2417 225.883 66.1751 226.015 66.1282C225.107 66.4506 224.198 66.755 223.314 67.1418C220.858 68.2123 219.63 68.7478 218.831 69.1531C217.571 69.7924 214.958 71.1339 211.953 73.4297C210.582 74.4767 209.045 75.651 207.309 77.5725C204.791 80.3608 203.445 82.9635 202.726 84.3774C201.916 85.9695 201.246 87.2855 200.744 89.2409C199.9 92.5289 200.157 95.1755 200.244 95.9261C200.358 96.9103 200.722 99.3403 202.125 102.071C202.686 103.161 203.657 105.053 205.568 106.774C206.091 107.246 207.623 108.549 207.569 108.616C207.566 108.62 207.558 108.618 207.329 108.546C207.112 108.476 207.079 108.466 207.079 108.466C206.743 108.354 206.459 108.262 206.354 108.226C206.032 108.116 205.334 107.829 204.637 107.475C203.017 106.655 201.655 105.634 201.655 105.634C201.205 105.296 199.493 103.981 197.752 101.736C197.165 100.979 195.718 99.0104 194.57 96.1018C193.165 92.5423 192.991 89.5574 192.909 87.9159C192.696 83.6632 193.494 80.4492 194.01 78.4389C194.951 74.7717 196.225 72.2244 197.302 70.0729C198.133 68.4139 199.516 65.8781 201.155 63.9182C202.752 62.0083 204.642 60.5849 204.668 60.5659C204.702 60.541 204.735 60.5145 204.769 60.4911C204.841 60.4422 204.861 60.4347 204.859 60.4242C204.854 60.3952 204.694 60.4122 204.472 60.3942C204.358 60.3848 204.29 60.3713 204.222 60.3608C203.964 60.3209 203.452 60.2859 202.911 60.274C202.679 60.269 202.13 60.2575 201.523 60.2939C201.221 60.3119 200.077 60.3918 198.611 60.781C196.973 61.2162 195.805 61.8076 195.476 61.9788C194.181 62.6521 193.307 63.3543 192.527 63.9886C192.055 64.3719 192.055 64.4028 190.43 65.8901C188.978 67.2181 188.242 67.8904 187.738 68.2917C186.63 69.1735 185.892 69.7614 184.73 70.3129C183.958 70.6797 182.578 71.3176 180.697 71.3435C179.859 71.355 179.229 71.2412 178.866 71.1733C178.442 71.094 176.679 70.7376 174.807 69.4889C173.911 68.8915 171.652 67.3384 170.524 64.2851C170.212 63.4411 169.492 61.1454 170.177 58.4009C170.408 57.4736 170.837 55.7553 172.392 54.3315C173.842 53.0034 175.436 52.697 175.781 52.6371C175.781 52.6371 177.664 52.3092 179.477 53.0643C179.588 53.1107 179.916 53.247 179.904 53.2844C179.897 53.3078 179.757 53.2824 179.731 53.2779C179.391 53.219 178.458 53.3218 177.636 53.6782C176.51 54.1663 175.883 55.0037 175.594 55.3995C175.269 55.8442 174.68 56.6517 174.58 57.8614C174.548 58.2452 174.479 59.2434 175.087 60.263C175.795 61.4533 176.95 61.875 177.442 62.0108C177.707 62.0841 178.872 62.406 179.984 61.864C180.232 61.7428 180.395 61.619 180.677 61.4039C181.541 60.7466 182.052 60.0559 182.232 59.8158C182.968 58.8361 183.837 57.9637 184.627 57.027C185.767 55.6765 186.337 55.0017 187.029 54.2047C187.67 53.4671 188.308 52.7459 188.796 52.163C189.127 51.7687 189.773 50.9792 189.824 50.9487C189.828 50.9467 189.856 50.9312 189.863 50.9028C189.863 50.9028 189.867 50.8883 189.863 50.8723C189.848 50.8145 189.407 50.7745 189.18 50.7371C189.078 50.7206 189.077 50.7136 188.74 50.6228C188.275 50.498 187.964 50.4262 187.829 50.3927C187.067 50.2031 185.922 49.7295 185.642 49.6122C184.431 49.1041 183.549 48.615 183.311 48.4813C182.825 48.2088 181.832 47.6258 180.668 46.73C180.155 46.3347 178.94 45.3625 177.596 43.8678C177.144 43.3657 176.382 42.5098 175.585 41.2961C174.228 39.2299 173.613 37.4042 173.273 36.3726C172.296 33.4071 172.162 30.9711 172.132 30.1681C172.033 27.4601 172.47 25.4374 172.903 23.4331C173.28 21.6873 173.607 20.8453 173.703 20.6008C174.024 19.7943 174.744 18.1942 176.165 16.5278C177.982 14.3978 180.084 13.168 180.148 13.2454C180.167 13.2678 180.018 13.4081 179.818 13.6257C178.939 14.5824 178.48 15.5062 178.147 16.1775C177.998 16.4759 177.289 17.9382 176.956 20.0603C176.6 22.3251 176.87 24.0938 177.026 25.064C177.453 27.7271 178.387 29.6121 178.647 30.1177C180.129 33.0044 182.096 34.6768 183.11 35.5217C185.32 37.3623 187.369 38.2277 188.814 38.8241C188.814 38.8241 191.774 40.0464 196.175 40.6447C196.576 40.6992 197.926 41.0969 197.984 40.5694C198.039 40.0768 197.313 39.2468 197.112 38.8062C196.888 38.3141 196.649 37.823 196.455 37.3179C195.51 34.8649 195.047 32.2508 194.951 29.6291C194.902 28.3021 194.944 26.972 195.054 25.649C195.152 24.4682 195.408 23.3377 194.987 22.1894C194.666 21.3155 194.097 20.6462 193.124 20.5145C192.373 20.4126 191.557 20.6517 190.957 21.1084C190.074 21.7796 189.818 22.7428 189.663 23.3233C189.579 23.6377 189.323 24.6398 189.543 25.8316C189.634 26.3307 189.851 27.0848 189.716 27.1392C189.687 27.1507 189.652 27.1267 189.63 27.1108C188.824 26.5363 188.818 26.5298 188.79 26.5029C188.232 25.9644 188.275 26.0108 188.239 25.9724C188.12 25.8441 187.522 25.1968 187.067 24.4113C186.296 23.0812 186.094 21.6334 186.04 21.1423C185.944 20.2829 185.738 18.4283 186.747 16.459C187.725 14.548 189.281 13.6352 189.922 13.2698C192.725 11.6748 195.53 12.2058 196.367 12.4024C198.238 12.8416 199.47 13.7694 199.863 14.0838C201.493 15.3874 202.224 16.9635 202.652 17.8868C203.109 18.873 203.369 19.7923 203.599 20.6088C203.802 21.3255 203.928 21.9323 204.173 23.1171C204.652 25.4364 204.614 25.6315 204.96 27.0933C205.343 28.7068 205.653 29.5792 205.761 29.8752C205.975 30.4631 206.216 31.1174 206.651 31.9368C207.376 33.3008 208.129 34.1632 208.303 34.3589C208.642 34.7412 209.032 35.1759 209.653 35.6395C210.857 36.5383 212.008 36.8019 213.452 37.0529C214.036 37.1542 213.481 36.3342 213.364 36.1546C211.289 32.956 210.542 28.8545 211.795 25.1823C211.946 24.7411 212.275 23.8198 213.156 23.2509C213.603 22.9629 214.043 22.8601 214.428 22.7708C215.139 22.6046 215.295 22.7224 216.329 22.5906C217.049 22.4988 217.42 22.4484 217.89 22.2303C218.592 21.9044 218.938 21.4727 219.031 21.3494C219.153 21.1897 219.228 21.054 219.264 20.9851Z",
    fill: "url(#paint0_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.582 57.2337C240.594 55.6486 240.608 53.9832 239.741 52.1301C238.941 50.4188 238.052 49.9602 236.499 47.1598C235.762 45.8308 235.389 45.1465 235.164 44.1708C235.025 43.567 234.463 41.125 235.698 39.0738C236.015 38.5477 236.394 38.14 237.139 37.339C238.269 36.1242 238.477 36.2001 238.98 35.4709C239.86 34.1953 240.135 32.5478 239.562 31.0885C239.504 30.9393 239.432 30.7871 239.306 30.6878C239.254 30.6473 239.17 30.6209 239.13 30.6733C239.115 30.6933 239.111 30.7192 239.109 30.7442C239.08 31.0067 239.115 31.2647 239.1 31.5262C239.057 32.8438 238.653 34.0406 237.713 34.9868C236.842 35.8642 235.739 36.5759 234.629 37.1109C233.833 37.4947 232.873 37.5656 232.002 37.5147C230.293 37.4148 228.613 36.7211 227.304 35.6241C227.15 35.4949 227 35.3591 226.856 35.2179C226.502 34.8695 226.166 34.4853 225.89 34.07C225.796 33.9268 225.575 33.6463 225.7 33.4976C226.018 33.6243 226.301 33.836 226.626 33.9577C228.148 34.5272 229.886 33.8554 231.13 32.8099C232.374 31.7648 233.279 30.3808 234.384 29.1895C235.36 28.138 236.585 27.1972 238.013 27.058C239.384 26.9242 240.803 27.6174 241.541 28.7808C242.026 28.1989 241.9 27.307 241.533 26.6447C240.694 25.1315 238.817 24.4014 237.093 24.5546C235.369 24.7078 233.792 25.6037 232.444 26.6892C231.096 27.7747 229.924 29.0603 228.604 30.1802C228.874 26.1886 230.178 22.2708 232.355 18.914C234.9 14.9873 238.715 11.8072 243.194 10.4482C246.211 9.53238 249.41 9.45502 252.568 9.49046C252.756 9.49245 252.87 9.28534 252.77 9.12613C252.362 8.47833 251.648 8.03814 250.951 7.68479C245.221 4.77867 238.042 5.05016 232.454 8.2218C226.867 11.3934 222.982 17.323 222.121 23.6902C221.927 25.1226 221.882 26.6138 222.353 27.9808C222.554 28.5657 222.85 29.197 222.625 29.7735C221.348 29.217 220.544 27.9653 219.539 27.0011C218.707 26.2036 217.66 25.5692 216.512 25.4734C215.363 25.3771 214.12 25.9161 213.613 26.9512C215.573 26.1846 218.017 26.9502 219.189 28.698C219.845 29.6751 220.108 30.8605 220.654 31.903C221.199 32.9456 222.213 33.9103 223.384 33.7955C223.34 33.8 223.112 34.2991 223.07 34.363C222.934 34.5726 222.782 34.7712 222.616 34.9579C222.283 35.3307 221.894 35.6531 221.466 35.9116C221.038 36.1706 220.592 36.2894 220.134 36.4681C219.636 36.6622 219.191 36.8883 218.637 36.9272C218.314 36.9497 217.94 36.8589 217.664 37.078C217.389 37.2961 217.52 37.6005 217.581 37.889C218.018 39.9516 217.161 41.8122 215.76 43.286C214.671 44.4309 213.348 45.3557 211.893 45.973C210.024 46.7661 208.034 47.2142 206.051 47.6105C204.097 48.0008 202.17 48.443 200.243 48.9196C196.377 49.8763 192.893 51.8771 189.838 54.4029C188.878 55.196 187.986 56.0669 187.165 57.0021C184.909 59.5729 184.442 60.3719 182.946 61.8177C181.809 62.9162 180.489 63.9458 178.468 63.8659C178.003 63.8475 175.468 63.7112 174.224 61.6241C173.15 59.8209 173.469 57.6255 173.899 56.4267C174.243 55.468 174.719 54.3386 175.912 53.6448C177.672 52.6217 179.911 53.3589 179.922 53.2805C179.931 53.2241 178.77 52.7919 177.261 52.8778C176.646 52.9127 174.751 53.037 173.178 54.4524C171.109 56.3149 171.07 59.0404 171.07 59.7361C171.07 62.1047 171.756 64.5512 173.611 66.4277C176.493 69.3438 180.389 68.5892 182.47 67.4683C184.718 66.258 186.501 64.2038 187.668 62.8139C189.616 60.4912 189.405 60.3475 191.15 58.6506C193.581 56.2865 195.433 54.7777 197.65 53.9383C198.956 53.4437 201.478 52.5079 204.815 52.217C206.601 52.0613 207.49 52.189 209.339 51.7698C210.188 51.5777 211.882 51.1245 213.782 50.0884C214.5 49.6966 217.701 47.8845 220.267 44.0241C221.798 41.7209 222.39 39.7595 222.549 39.8209C222.718 39.8868 222.1 42.1666 221.168 44.4443C219.693 48.0457 217.88 50.5565 217.145 51.5297C215.507 53.6972 214.815 54.0646 210.3 58.3746C203.404 64.9579 201.989 66.9922 201.393 67.8885C199.469 70.7822 198.457 73.276 197.851 74.7937C196.733 77.5916 195.205 81.4135 195.089 86.6224C195.041 88.7774 194.995 92.5839 196.83 96.9498C197.324 98.1246 198.763 101.318 201.814 104.396C204.628 107.234 207.534 108.69 207.589 108.613C207.642 108.538 204.918 107.157 202.595 104.215C200.522 101.591 199.83 98.9706 199.112 96.6498C198.601 94.9999 197.326 90.7792 198.031 85.6617C198.802 80.067 201.53 76.3449 203.855 73.1722C205.011 71.5952 208.685 66.6762 214.784 62.9646C215.608 62.463 217.703 61.2368 220.748 59.2754C224.503 56.8569 225.708 55.8927 226.752 54.2916C227.977 52.4146 228.398 50.5526 228.554 49.5479C228.86 47.5736 228.59 46.0149 228.193 43.7237C227.72 40.9907 227.083 39.2494 227.173 39.2205C227.28 39.1861 228.252 41.6735 229.154 44.5646C229.984 47.2237 230.662 49.3947 231.075 52.4306C231.534 55.7964 231.413 58.3541 231.376 59.0354C231.333 59.8 231.186 62.2684 230.535 64.7997C229.191 70.032 226.846 71.0656 224.03 76.815C223.015 78.8882 221.684 81.6067 221.068 85.3812C220.741 87.3915 219.889 93.0964 222.75 99.3114C224.732 103.617 227.534 106.121 228.274 106.757C233.108 110.91 239.881 111.816 239.887 111.798C239.889 111.793 238.785 111.506 237.401 110.946C236.347 110.52 235.539 110.194 234.839 109.845C233.201 109.03 232.093 108.066 231.41 107.464C230.487 106.65 228.168 104.56 226.687 100.979C225.816 98.8757 225.614 97.1609 225.446 95.735C224.987 91.8532 225.588 88.8318 225.806 87.8491C226.18 86.1682 226.836 84.1504 229.168 80.0435C232.517 74.1499 233.433 74.3146 236.374 69.2355C240.287 62.476 240.569 58.8941 240.582 57.2337Z",
    fill: "url(#paint1_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.031 39.3681C200.87 39.1724 200.722 38.9673 200.59 38.7517C199.897 37.6228 199.309 36.428 198.842 35.1888C198.087 33.186 197.829 31.556 197.641 30.3253C197.305 28.1204 197.288 25.8855 197.263 23.6606C197.247 22.2108 197.292 20.4436 196.439 19.1579C195.36 17.5324 192.895 17.243 191.217 18.0165C189.307 18.8969 188.79 20.9406 188.695 21.3189C188.048 23.9027 189.956 27.0039 189.725 27.1067C189.518 27.1991 187.389 24.8185 186.969 22.3815C186.802 21.4173 186.701 18.7188 188.09 16.67C189.561 14.4991 192.367 13.6267 194.882 14.0753C199.764 14.9457 201.515 20.2689 202.346 24.4701C203.007 27.8169 203.436 31.4357 205.041 34.4911C205.816 35.9649 206.914 37.1517 208.457 37.8189C209.37 38.2137 211.406 38.317 211.752 39.4519C212.04 40.4007 211.169 41.6359 210.311 42.2138C207.439 44.1473 202.921 41.6628 201.031 39.3681Z",
    fill: "url(#paint2_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.564 15.9409C177.605 15.8955 177.648 15.8501 177.69 15.8047C176.202 18.588 175.525 21.7986 175.762 24.9458C176.18 30.4841 179.498 35.6111 183.981 38.7767C184.833 39.3786 185.731 39.9151 186.665 40.3788C188.943 41.5082 191.419 42.2318 193.942 42.5323C195.908 42.7664 197.71 42.6411 199.651 42.3092C200.272 42.2029 201.117 42.1744 201.381 42.8821C201.977 44.4787 200.604 45.8686 199.286 46.458C197.966 47.0479 196.478 47.2511 195.047 47.3394C192.218 47.5141 189.34 46.9816 186.721 45.911C183.095 44.4288 179.903 41.8835 177.912 38.4828C177.458 37.7067 177.058 36.8987 176.705 36.0722C175.496 33.245 174.572 30.228 174.292 27.1557C174.051 24.5191 174.217 21.9104 175.294 19.45C175.856 18.1688 176.62 16.9745 177.564 15.9409Z",
    fill: "url(#paint3_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.966 51.9474C241.389 52.3621 242.26 53.6887 242.52 54.8495C242.919 56.6282 242.927 58.6455 242.649 60.5729C242.424 62.1331 241.888 63.8184 242.086 65.4909C242.41 68.2118 244.473 70.1418 246.291 72.0003C248.339 74.094 250.273 76.0174 250.973 79.0104C251.873 82.8598 251.923 89.199 248.411 91.6969C246.108 93.3354 241.572 93.4282 239.364 91.1365C238.048 89.7705 237.709 87.7213 238.003 86.0928C239.057 80.2486 244.848 80.9158 244.235 80.8889C243.977 80.8779 238.978 80.3554 236.949 85.1855C235.664 88.2473 236.612 92.2344 239.04 94.2986C241.096 96.0459 243.851 96.4636 246.45 96.0199C255.748 94.4319 260.477 83.4242 258.462 74.9374C256.788 67.8834 252.786 61.6175 247.851 56.3912C247.428 55.943 242.952 51.2397 241.966 51.9474Z",
    fill: "url(#paint4_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.206 61.5658C254.232 61.6391 254.275 61.7095 254.317 61.7764C255.977 64.4444 257.337 67.2752 258.453 70.2108C258.601 70.5971 259.463 72.53 260.135 73.6135C260.966 74.955 261.962 74.9515 262.496 75.3348C264.435 76.7238 268.538 78.5683 273.705 78.0967C278.195 77.687 283.707 75.7675 286.07 71.6856C286.697 70.6031 287.631 68.7151 287.879 67.3022C288.103 66.0235 288.174 61.3986 287.893 59.4786C287.892 59.4761 287.888 59.4756 287.888 59.4786C287.495 61.3976 288.02 64.8936 285.267 69.5101C282.338 74.422 276.203 74.4829 271.282 72.6094C269.461 71.9161 267.729 70.9754 266.149 69.8365C264.844 68.8962 263.646 67.8062 262.593 66.5905C261.733 65.5978 260.971 64.5278 260.171 63.4877C259.38 62.4581 258.629 61.416 257.357 60.9659C256.798 60.7677 254.271 60.4284 254.181 61.3956C254.175 61.454 254.186 61.5109 254.206 61.5658Z",
    fill: "url(#paint5_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.844 40.4078C281.565 40.4267 283.959 41.3141 284.412 41.5791C284.912 41.8716 285.381 42.2164 285.812 42.6022C286.68 43.3778 287.396 44.3205 287.923 45.3571C288.925 47.3265 289.375 49.9701 288.462 52.0428C287.216 54.87 284.452 56.7321 281.394 57.2322C277.891 57.8046 274.397 56.1966 272.475 53.2126C271.69 51.9929 271.045 50.6578 270.375 49.3747C269.649 47.9838 268.569 46.4636 267.132 45.8322C264.955 44.875 261.669 45.2513 259.627 46.4726C258.011 47.4398 256.277 48.5412 255.051 49.9696C253.419 51.8696 252.409 54.3769 249.521 53.8464C248.445 53.6488 247.44 53.1732 246.482 52.6451C243.976 51.2647 241.688 49.482 239.815 47.314C238.707 46.0324 237.797 44.5506 237.363 42.9136C236.971 41.4354 238.647 41.5472 239.618 41.6684C242.658 42.0487 245.696 42.1565 248.673 41.3326C251.525 40.5435 254.157 39.1566 256.904 38.0846C260.925 36.5145 265.694 35.3281 269.789 37.3235C272.314 38.5532 274.227 40.9458 274.938 43.6627C275.329 45.1605 275.373 46.7281 275.697 48.2418C276.022 49.7555 276.7 51.2946 278 52.1351C279.241 52.9376 280.855 52.9631 282.281 52.5753C283.783 52.167 285.207 51.2847 285.996 49.9436C286.883 48.4354 286.944 46.6333 286.124 45.0881C285.551 44.0076 285.204 41.886 280.844 40.4078Z",
    fill: "url(#paint6_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.835 12.9071C255.881 12.8532 255.956 12.8323 256.069 12.8727C256.256 12.9396 256.399 13.1517 256.506 13.3059C256.812 13.7446 257.037 14.2422 257.249 14.7312C257.29 14.8271 257.33 14.9234 257.371 15.0192C257.833 16.1017 258.134 17.2486 258.284 18.4154C258.626 21.0785 257.96 23.7416 256.555 26.0289C255.389 27.9274 254.64 28.8551 252.971 30.3045C252.717 30.5256 251.378 31.6849 250.991 31.62C250.472 31.5332 250.579 30.1238 250.551 29.7415C250.431 28.1445 249.878 26.5953 248.657 25.5108C248.238 25.1395 247.712 24.613 248.356 24.1334C248.75 23.8404 249.259 23.8035 249.719 23.6777C252.14 23.0154 254.253 21.3241 255.431 19.1072C255.795 18.4214 256.085 17.6878 256.214 16.9192C256.417 15.6985 256.12 14.4747 255.799 13.3019C255.761 13.1641 255.761 12.9935 255.835 12.9071Z",
    fill: "#6222DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.957 30.8395C235.001 30.7777 235.048 30.7173 235.099 30.6589C236.018 29.5983 238.28 29.5504 238.381 31.3032C238.411 31.8087 238.242 32.3193 238.055 32.7829C237.614 33.8784 236.687 34.671 235.641 35.1695C234.756 35.5913 233.764 35.7535 232.789 35.7205C232.297 35.704 231.807 35.6382 231.328 35.5274C231.154 35.4874 230.142 35.3058 230.148 35.0692C230.15 34.9879 230.316 34.9295 230.422 34.896C231.094 34.6829 231.821 34.7179 232.462 34.4005C233.425 33.9228 233.884 32.9891 234.33 32.0633C234.53 31.646 234.688 31.2163 234.957 30.8395Z",
    fill: "#E3DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.187 34.5993C219.223 34.2529 218.623 34.0188 218.131 33.649C217.511 33.1829 217.199 32.6024 216.837 31.9312C216.462 31.235 216.334 30.697 216.167 30.7194C216.136 30.7234 216.055 30.7539 215.975 31.1641C215.901 31.5374 215.795 32.0794 216.012 32.7861C216.09 33.0431 216.472 34.2873 217.609 34.7305C218.112 34.9267 218.938 35.0345 219.141 34.7305C219.178 34.6741 219.185 34.6197 219.187 34.5993Z",
    fill: "#E3DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.406 17.9991C188.002 16.4575 189.049 15.2232 190.642 14.5495C192.1 13.9326 193.641 13.7864 195.189 14.1188C198.078 14.7396 199.887 17.1577 200.967 19.7064C202.048 22.2582 202.427 24.9018 202.959 27.6937C203.472 30.3847 204.135 33.2849 205.679 35.5392C205.279 34.9927 204.852 34.4307 204.503 33.8323C204.165 33.2519 203.849 32.6585 203.582 32.0421C203.042 30.792 202.659 29.4794 202.352 28.1548C201.824 25.8755 201.487 23.5488 200.798 21.313C200.14 19.1734 199.092 17.0454 197.279 15.7328C195.727 14.6094 193.684 14.1931 191.816 14.6193C189.949 15.0451 188.317 16.3137 187.406 17.9991Z",
    fill: "url(#paint7_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.764 22.5912C175.785 22.3647 175.611 25.1196 176.145 27.3829C177.034 31.1459 178.806 33.546 179.755 34.7577C180.424 35.6117 182.409 38.0018 185.788 39.9092C185.788 39.9092 188.744 41.5781 192.264 42.2649C193.248 42.457 194.043 42.5374 194.043 42.5374C194.602 42.5938 195.085 42.6277 194.983 42.6217C194.95 42.6197 193.44 42.6796 192.366 42.6337C191.591 42.6008 188.931 42.2798 186.261 41.1744C182.489 39.6128 180.235 36.8649 178.942 35.0283C177.912 33.5655 176.198 31.0731 175.713 27.5296C175.403 25.2623 175.756 22.6781 175.764 22.5912Z",
    fill: "url(#paint8_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.303 41.9129C242.63 41.8694 245.287 42.2338 248.898 41.2536C249.711 41.033 250.548 40.767 252.397 39.9734C255.3 38.7277 255.504 38.6005 257.259 37.8968C259.151 37.1382 261.126 36.5772 263.681 36.3122C264.791 36.1969 266.757 36.1755 268.774 36.8507C269.551 37.1107 270.454 37.6133 271.299 38.2317C271.743 38.5561 272.102 38.9134 272.22 39.0207C272.57 39.3381 272.949 39.8177 272.89 39.7444C272.846 39.6885 271.995 38.9049 270.399 38.0026C269.027 37.2275 267.815 36.9291 267.356 36.8283C265.616 36.4465 264.23 36.6117 263.167 36.7484C262.276 36.8627 260.961 37.1067 258.63 38.0026C255.586 39.1729 255.611 39.6096 252.946 40.6981C251.147 41.4327 248.897 42.3281 245.954 42.3795C243.93 42.4144 242.177 41.9293 242.303 41.9129Z",
    fill: "url(#paint9_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.789 59.7031C253.153 62.6237 254.697 65.2938 255.683 67.2597C257.071 70.027 257.759 72.2045 257.988 72.9736C258.268 73.9124 258.531 74.7798 258.725 75.9471C258.889 76.9338 259.219 79.4282 258.646 82.5459C258.387 83.9548 257.708 86.8559 255.592 89.9936C253.548 93.023 250.869 94.4309 250.872 94.4344C250.874 94.4364 251.709 93.8246 252.701 92.8024C254.173 91.2838 255.431 89.4646 256.128 87.4339C256.92 85.1281 257.173 82.5364 257.104 80.1264C256.983 75.9346 255.91 71.8302 254.494 67.887C254.274 67.2751 254.036 66.6702 253.78 66.0729C253.324 65.0143 252.844 63.9667 252.407 62.9002C251.832 61.4993 251.22 60.4103 250.789 59.7031Z",
    fill: "url(#paint10_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.072 59.7346C171.07 60.1698 171.093 60.7203 171.184 61.3506C171.288 62.0723 171.44 62.6048 171.479 62.739C171.606 63.1767 171.911 64.1933 172.671 65.2883C173.013 65.7809 173.662 66.6952 174.858 67.4334C175.116 67.5921 176.352 68.3861 178.11 68.451C179.991 68.5204 181.387 67.9973 182.066 67.6909C182.974 67.2811 183.567 66.81 184.255 66.2795C185.527 65.2993 186.376 64.3231 187.496 63.019C188.285 62.0992 188.992 61.12 189.761 60.1843C190.74 58.993 191.835 57.9549 193.011 56.9567C194.347 55.8228 195.78 54.7149 197.397 54.0421C199.424 53.1997 202.112 52.6577 204.429 52.2504C200.639 51.9465 196.536 52.9092 193.301 54.907C192.493 55.4061 191.728 55.975 191.026 56.6149C190.459 57.1304 189.934 57.6919 189.463 58.2957C188.301 59.783 187.353 61.4245 186.165 62.8918C185.75 63.4033 185.307 63.8924 184.822 64.3381C182.2 66.7481 178.401 68.2369 175.076 66.3434C173.884 65.6646 172.859 64.6635 172.2 63.4572C171.471 62.1267 171.039 60.59 171.072 59.7346Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.869 42.8168C206.319 42.7439 205.484 42.4934 204.698 42.1206C204.478 42.0163 204.049 41.8281 203.459 41.4763C201.76 40.4627 200.748 39.0518 200.565 38.7608C200.201 38.1824 199.963 37.7631 199.614 37.0869C198.65 35.2174 198.228 33.4771 197.991 32.4879C197.375 29.9206 197.309 26.4111 197.305 26.3438C197.368 27.3948 197.73 30.3084 198.006 31.3161C198.973 34.8291 199.857 37.6329 202.621 40.1612C203.226 40.7142 204.203 41.4982 204.891 41.9434C205.417 42.2843 206.247 42.684 206.869 42.8168Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.978 52.8664C246.906 52.4616 248.939 52.0628 250.794 51.0812C252.109 50.3849 252.985 49.3264 254.049 48.3243C255.391 47.0606 256.896 45.9132 258.542 45.0698C260.229 44.2044 262.105 43.5376 264.027 43.4313C265.372 43.3569 266.891 43.5067 268.072 44.2089C269.146 44.8467 269.95 45.8558 270.519 46.9523C271.47 48.7849 272.488 50.601 273.596 52.3448C275.198 54.8667 278.044 56.8405 281.15 56.5456C282.9 56.3799 284.203 55.9771 284.712 55.7715C285.955 55.2709 286.77 54.4739 287.126 54.1405C287.249 54.0247 286.021 55.3897 284.543 56.1727C283.004 56.9887 281.644 57.1968 281.349 57.2383C280.529 57.3546 278.35 57.6545 275.986 56.4542C275.099 56.0046 274.386 55.4087 274.078 55.1377C273.612 54.7274 273.239 54.5403 272.058 52.5045C271.653 51.8078 271.253 51.1096 270.899 50.3859C270.449 49.4671 269.955 48.5658 269.331 47.7523C269.074 47.4169 268.817 47.085 268.508 46.7961C268.129 46.4422 267.702 46.1433 267.236 45.9172C266.313 45.4705 265.298 45.3473 264.534 45.3203C264.136 45.3063 262.89 45.2065 261.194 45.774C260.291 46.0759 259.715 46.4263 258.732 47.0192C257.68 47.6545 256.811 48.2489 255.716 49.2735C254.897 50.0396 254.079 51.2234 254.031 51.2878C253.565 51.9101 253.371 52.2345 252.879 52.7007C252.429 53.1279 251.98 53.5446 251.268 53.7677C250.552 53.9918 249.996 53.9119 249.582 53.8525C249.306 53.8131 248.664 53.6913 247.577 53.1987C247.102 52.9826 246.991 52.9382 246.978 52.8664Z",
    fill: "url(#paint11_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.886 111.8C239.854 111.883 234.555 110.497 230.7 106.817C229.949 106.1 229.401 105.437 229.247 105.249C227.307 102.87 226.483 100.557 226.169 99.5414C225.777 98.2732 225.648 97.31 225.515 96.3218C225.326 94.9119 225.004 92.3542 225.561 89.1421C226.043 86.3677 226.967 84.3425 227.548 83.0913C228.023 82.0677 228.464 81.2871 229.061 80.2331C229.595 79.2898 230.521 77.7152 231.834 75.8027C233.265 73.7196 233.358 73.8543 234.55 72.1345C236.467 69.3701 237.608 67.031 237.988 66.2289C238.839 64.4303 239.662 62.6166 240.117 60.6717C240.454 59.2319 240.543 58.1678 240.575 57.6059C240.645 56.3781 240.718 55.096 240.253 53.5329C240.185 53.3063 239.858 52.0716 239.018 50.8843C238.498 50.1477 238.393 50.0294 237.714 49.0422C236.84 47.7721 236.578 47.3134 236.581 47.3204C237.095 48.4189 238.58 50.6787 239.056 51.7013C240.544 54.8954 240.452 57.1507 239.598 60.5814C237.479 69.1026 229.375 74.8161 225.827 82.7674C225.79 82.8497 225.754 82.9321 225.718 83.0149C225.015 84.6339 224.474 86.3228 224.152 88.0601C223.341 92.4455 223.62 97.1518 225.396 101.277C226.638 104.164 228.643 106.688 231.273 108.429C233.9 110.169 236.752 111.022 239.767 111.765C239.774 111.765 239.89 111.788 239.886 111.8Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.494 65.7111C256.555 65.6817 257.685 68.8718 260.503 72.1532C261.256 73.0311 261.86 73.7338 262.825 74.4749C265.812 76.7707 269.046 77.3501 271.184 77.5173C273.026 77.661 276.147 77.6925 279.465 76.353C283.527 74.7135 285.731 72.2171 285.972 71.8393C286.066 71.6931 285.22 73.1184 284.363 73.8666C283.641 74.4974 282.947 75.0419 281.86 75.6583C279.393 77.0587 276.935 77.6047 275.699 77.8213C274.3 78.0663 272.142 78.4506 268.869 77.8901C265.697 77.3466 263.549 76.1084 263.321 75.9248C263.292 75.9018 262.616 75.4102 262.314 75.227C262.145 75.1252 261.999 75.1018 261.943 75.0808C261.943 75.0808 261.366 74.9061 260.826 74.4804C260.351 74.1056 260.121 73.6345 259.924 73.2662C259.049 71.6297 258.679 70.8052 258.175 69.5076C257.289 67.2263 256.45 65.7321 256.494 65.7111Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.115 27.6966C250.286 26.9795 251.582 26.7514 252.153 26.5463C253.951 25.8995 255.528 24.6977 256.538 23.0542C257.192 21.9897 257.613 20.8563 257.911 19.648C258.084 18.9483 258.226 18.031 258.091 17.3203C258.139 17.5723 258.638 19.392 258.172 21.8724C258.122 22.1399 257.963 22.9359 257.594 23.9131C257.594 23.9131 256.56 27.1322 253.349 29.9664C252.889 30.3722 252.854 30.4211 252.219 30.9217C251.947 31.1363 251.64 31.3409 251.36 31.5071C251.306 31.539 251.179 31.6418 251.023 31.6229C250.913 31.6094 250.837 31.5445 250.812 31.5231C250.551 31.299 250.578 30.9811 250.535 30.3248C250.529 30.2354 250.485 29.6625 250.369 29.0511C250.123 27.7535 250.094 27.782 250.115 27.6966Z",
    fill: "url(#paint12_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.619 79.5754C199.783 79.0229 199.981 78.4804 200.209 77.9514C201.419 75.1481 202.764 72.9082 203.902 71.2443C206.11 68.0148 208.242 65.9196 208.866 65.3197C210.022 64.2073 211.89 62.4321 214.71 60.7562C215.505 60.284 217.189 59.4541 220.554 57.7942C221.953 57.1044 223.625 56.2934 225.278 54.6719C225.987 53.9762 226.453 53.3658 226.569 53.2131C228.062 51.2353 228.504 49.7884 228.551 49.5434C228.572 49.4351 228.359 51.373 227.328 53.2945C226.697 54.4713 226.044 55.2344 225.899 55.4011C225.506 55.8517 224.943 56.4197 223.025 57.7627C222.513 58.1215 221.797 58.6106 220.092 59.6896C219.026 60.3639 218.493 60.6873 216.057 62.192C213.721 63.6354 213.507 63.7731 213.161 64.0107C212.824 64.2422 211.425 65.1665 209.832 66.6069C207.325 68.8727 205.574 70.8939 204.515 72.2844C202.93 74.3645 201.821 75.8882 200.577 78.0971C199.76 79.5489 199.155 81.1874 199.18 81.1091C199.287 80.7862 199.413 80.2686 199.619 79.5754Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.174 39.2193C228.78 46.0467 225.426 53.4301 219.174 56.5423C214.98 58.6305 210.895 60.4831 207.279 63.5524C203.469 66.7859 200.753 71.1553 199.214 75.8871C198.415 78.3445 197.949 80.8923 197.787 83.4706C197.769 83.7446 197.601 88.2078 197.831 88.2133C197.848 88.2138 197.828 87.313 197.988 86.0114C198.067 85.3631 198.255 84.0854 199.075 81.4109C199.523 79.9516 199.879 78.7897 200.47 77.3738C201.68 74.4762 203.057 72.4689 204.011 71.0959C205.029 69.6306 206.824 67.0794 209.856 64.3943C210.536 63.7919 212.988 61.6194 215.738 60.2016C216.867 59.6191 218.265 58.9309 218.265 58.9309C219.854 58.1479 220.162 58.0271 221.057 57.5515C222.332 56.8752 222.969 56.5368 223.709 55.9988C224.292 55.5746 225.34 54.7437 226.385 53.4585C227.236 52.41 227.725 51.5036 227.962 51.024C228.405 50.1307 228.533 49.5987 228.575 49.4085C228.755 48.596 228.715 47.9442 228.681 47.5C228.506 45.1988 228.086 43.1331 227.866 42.0626C227.315 39.39 227.159 39.156 227.174 39.2193Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.112 30.7313C239.1 30.7718 239.099 30.8172 239.099 30.8601C239.093 31.6896 239.062 32.5759 238.75 33.3555C238.577 33.8007 238.32 34.2099 238.025 34.5842C237.969 34.6551 237.912 34.7244 237.853 34.7933C237.414 35.3059 236.897 35.752 236.339 36.1303C235.739 36.5371 235.088 36.863 234.423 37.15C233.734 37.4469 233.031 37.5318 232.284 37.5023C231.02 37.4514 229.73 37.149 228.633 36.5047C228.403 36.3689 228.179 36.2212 227.959 36.069C227.865 36.0036 227.729 35.8658 227.612 35.8429C227.604 35.8409 227.588 35.8324 227.581 35.8429C227.536 35.9038 228.122 36.4587 228.768 36.9194C229.782 37.6426 230.948 38.1441 232.171 38.3837C232.931 38.5329 233.715 38.6083 234.49 38.5743C235.122 38.5469 235.811 38.4546 236.355 38.1072C236.469 38.0343 236.576 37.9495 236.668 37.8502C236.758 37.7538 236.952 37.5178 237.308 37.1619C237.727 36.7427 237.918 36.6539 238.353 36.2142C238.664 35.9008 238.801 35.7291 238.959 35.522C239.366 34.9845 239.527 34.4719 239.611 34.2184C239.611 34.2184 240.132 32.8644 239.694 31.471C239.638 31.2923 239.599 31.1061 239.518 30.9359C239.47 30.8351 239.275 30.4988 239.14 30.6754C239.127 30.6919 239.119 30.7109 239.112 30.7313Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.618 26.9472C213.6 26.9073 214.222 26.4401 214.973 26.2535C216.161 25.958 217.403 26.4327 218.366 27.1204C219.254 27.7547 219.855 28.688 220.265 29.6856C220.712 30.7746 220.811 32.2823 221.782 33.0729C222.024 33.269 222.27 33.4796 222.553 33.5964C222.65 33.6363 223.301 33.7681 223.389 33.7911C223.424 33.8005 223.001 33.822 222.68 33.7382C222.165 33.6034 221.831 33.3174 221.634 33.1527C221.251 32.8328 221.035 32.5129 220.875 32.2694C220.636 31.9085 220.501 31.5901 220.24 30.9678C219.969 30.323 219.993 30.2815 219.763 29.772C219.551 29.3004 219.418 29.0069 219.161 28.6456C218.837 28.1894 218.506 27.896 218.355 27.7697C218.221 27.6574 217.78 27.3016 217.107 27.0241C216.519 26.7815 216.01 26.7042 215.714 26.6747C215.495 26.6532 215.096 26.6163 214.592 26.6942C214.001 26.7855 213.631 26.9772 213.618 26.9472Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.7 34.0569C228.606 34.0973 230.021 33.8567 231.36 32.599C231.689 32.2901 232.038 31.9722 232.661 31.2186C233.468 30.2444 233.483 30.176 234.044 29.5572C234.806 28.7157 235.372 28.0909 236.317 27.6033C237.361 27.0653 238.487 26.8587 239.62 27.2659C240.375 27.5374 241.04 28.0549 241.488 28.7202C241.503 28.7422 241.521 28.7666 241.547 28.7696C241.582 28.7736 241.607 28.7402 241.624 28.7097C241.731 28.5211 241.794 28.3105 241.829 28.0969C241.871 27.8463 241.875 27.5858 241.805 27.3423C241.641 26.7818 241.109 26.4035 240.563 26.1994C239.673 25.8665 238.678 25.883 237.758 26.12C236.389 26.4729 235.006 27.2654 233.999 28.2566C233.469 28.7786 233.016 29.3775 232.567 29.9689C232.263 30.3707 231.959 30.7729 231.657 31.1772C231.348 31.5909 231.066 32.0521 230.723 32.4373C230.15 33.0836 229.504 33.7095 228.7 34.0569Z",
    fill: "#561FDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.5 39.8392C222.38 39.9235 219.472 44.7067 215.256 47.3144C212.835 48.8126 211.74 48.9583 206.79 50.201C202.539 51.2686 196.551 51.2945 193.135 54.3973C192.521 54.9548 191.705 56.0268 191.644 56.0762C191.552 56.151 192.038 55.7593 192.424 55.4833C193.524 54.6947 194.425 54.2291 195.402 53.7929C196.843 53.1491 198.115 52.8102 198.986 52.6246C199.495 52.5158 201.068 52.2043 203.042 52.2193C203.612 52.2238 203.729 52.2517 204.445 52.2478C205.963 52.2393 207.095 52.1045 207.446 52.0601C208.178 51.9678 209.146 51.8455 210.358 51.4996C211.021 51.3105 212.429 50.8623 214.052 49.9315C214.371 49.7484 215.828 48.8989 217.438 47.3783C217.96 46.8852 218.894 45.9464 219.857 44.6084C220.677 43.4685 221.397 42.2058 221.69 41.5141C221.747 41.3768 221.921 41.029 222.15 40.5299C222.392 40.0019 222.545 39.8077 222.5 39.8392Z",
    fill: "#6A3DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.914 18.9657C190.593 18.2884 191.325 17.6296 192.218 17.2778C193.71 16.6894 195.545 17.1171 196.624 18.3039C197.514 19.2831 197.861 20.6431 197.97 21.9616C198.112 23.6705 198.061 25.3938 198.182 27.1051C198.21 27.4989 198.241 27.8927 198.272 28.2864C198.563 31.9317 199.818 35.6124 202.189 38.4352C203.827 40.3851 206.299 42.4403 208.971 42.062C209.989 41.9177 211.029 41.1187 211.724 40.3611C211.44 41.4242 210.533 42.2626 209.499 42.6394C208.465 43.0162 207.344 43.0102 206.299 42.6664C205.253 42.323 204.272 41.6567 203.424 40.955C202.194 39.9374 201.138 38.7117 200.304 37.3512C199.453 35.9628 198.945 34.478 198.468 32.9324C198.034 31.5275 197.618 30.1056 197.477 28.6398C197.314 26.9564 197.236 25.265 197.241 23.5736C197.243 22.7502 197.265 21.9222 197.14 21.1082C197.015 20.2942 196.733 19.4842 196.194 18.8619C195.342 17.8772 193.939 17.4924 192.645 17.6376C191.616 17.7539 190.602 18.1916 189.914 18.9657Z",
    fill: "#6A3DF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.831 82.4886C239.141 83.1184 238.792 83.8007 238.62 84.142C238.556 84.2708 238.273 84.8457 238.086 85.6692C237.997 86.0645 237.823 86.862 237.934 87.8911C237.985 88.3593 238.083 89.1852 238.594 90.0876C239.327 91.3822 240.426 91.9781 240.819 92.1852C241.721 92.6593 242.5 92.7591 243.125 92.8395C243.757 92.9208 245.141 93.082 246.762 92.5016C247.286 92.3144 248.148 92.005 248.963 91.2439C249.609 90.642 250.005 89.9648 250.046 89.8929C250.339 89.3839 250.52 88.9402 250.513 88.9866C250.488 89.1463 250.442 89.7861 250.165 90.4644C249.604 91.8363 248.524 92.6034 248.143 92.8659C246.18 94.2229 243.973 93.9789 243.32 93.9065C242.396 93.8042 240.053 93.5457 238.496 91.5449C237.003 89.6259 237.246 87.409 237.315 86.7812C237.385 86.1483 237.578 84.3926 238.916 83.0985C239.514 82.521 240.301 82.0868 240.33 82.0704C240.34 82.0664 240.098 82.2441 239.831 82.4886Z",
    fill: "url(#paint13_linear_10061_157235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.65 29.6037C174.65 29.6002 174.649 29.5972 174.648 29.5938C174.906 30.9547 175.455 32.3097 175.991 33.5819C176.542 34.8915 177.196 36.1576 177.944 37.3654C179.423 39.752 181.287 41.9055 183.578 43.544C185.918 45.2169 188.636 46.3807 191.484 46.8179C193.063 47.0605 194.661 47.0904 196.241 46.8698C197.73 46.6617 199.103 46.3548 200.43 45.6087C200.546 45.5438 200.654 45.4694 200.767 45.3995C199.9 46.3857 198.58 46.8029 197.333 47.0505C195.85 47.3449 194.326 47.4288 192.818 47.329C190.81 47.1962 188.825 46.7381 186.953 45.9989C185.613 45.4699 184.63 44.9139 184.181 44.6489C182.52 43.6677 181.412 42.6746 181.029 42.3202C179.969 41.3405 179.277 40.4622 179 40.0988C177.213 37.7497 176.037 34.869 175.242 32.0412C175.014 31.2332 174.807 30.4282 174.65 29.6037Z",
    fill: "#561FDB"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter30_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 317.767,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 329.767,
    cy: 37.6693,
    r: 1.33333,
    fill: "#FCFCFD"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter32_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 341.767,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter33_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 353.767,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter34_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 365.767,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 377.767,
    cy: 37.6693,
    r: 1.33333,
    fill: "#5834A8"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter36_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.767,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter37_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 401.767,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter38_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 413.767,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter39_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 425.767,
    cy: 37.6693,
    r: 1.33333,
    fill: "#777E90"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter40_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 329.767,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter41_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 341.767,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter42_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 353.767,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter43_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 365.767,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 377.767,
    cy: 56.3372,
    r: 1.33333,
    fill: "#372069"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter45_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.767,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter46_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 401.767,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter47_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 413.767,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 425.767,
    cy: 56.3372,
    r: 1.33333,
    fill: "#FCFCFD"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter49_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 437.767,
    cy: 56.3372,
    r: 1.33333,
    fill: "#777E90"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter50_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 317.767,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 329.767,
    cy: 75.0013,
    r: 1.33333,
    fill: "#5834A8"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter52_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 341.767,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter53_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 353.767,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter54_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 365.767,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter55_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 377.767,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 389.767,
    cy: 75.0013,
    r: 1.33333,
    fill: "#6F41D2",
    fillOpacity: 0.25,
    shapeRendering: "crispEdges"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter57_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 401.767,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter58_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 413.767,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter59_d_10061_157235)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 425.767,
    cy: 75.0013,
    r: 1.33333,
    fill: "#777E90"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10061_157235",
    x: 27.6984,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10061_157235",
    x: 39.6984,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_10061_157235",
    x: 51.6984,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_10061_157235",
    x: 63.6984,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_10061_157235",
    x: 75.6984,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_10061_157235",
    x: 87.6984,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.435294 0 0 0 0 0.968627 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_10061_157235",
    x: 99.6984,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_10061_157235",
    x: 111.698,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_10061_157235",
    x: 123.698,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_10061_157235",
    x: 135.698,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_10061_157235",
    x: 15.6984,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_10061_157235",
    x: 27.6984,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_10061_157235",
    x: 39.6984,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_10061_157235",
    x: 51.6984,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_10061_157235",
    x: 63.6984,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.282353 0 0 0 0 0.6 0 0 0 0 0.921569 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_10061_157235",
    x: 75.6984,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_10061_157235",
    x: 87.6984,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_10061_157235",
    x: 99.6984,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_10061_157235",
    x: 111.698,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988235 0 0 0 0 0.988235 0 0 0 0 0.992157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_10061_157235",
    x: 123.698,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_10061_157235",
    x: 27.6984,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_10061_157235",
    x: 39.6984,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_10061_157235",
    x: 51.6984,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_10061_157235",
    x: 63.6984,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_10061_157235",
    x: 75.6984,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_10061_157235",
    x: 87.6984,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_10061_157235",
    x: 99.6984,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.701961 0 0 0 0 0.941176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_10061_157235",
    x: 111.698,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_10061_157235",
    x: 123.698,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_10061_157235",
    x: 135.698,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_10061_157235",
    x: 313.234,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_10061_157235",
    x: 325.234,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_10061_157235",
    x: 337.234,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_d_10061_157235",
    x: 349.234,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_d_10061_157235",
    x: 361.234,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_d_10061_157235",
    x: 373.234,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.435294 0 0 0 0 0.968627 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_d_10061_157235",
    x: 385.234,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_d_10061_157235",
    x: 397.234,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_d_10061_157235",
    x: 409.234,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_d_10061_157235",
    x: 421.234,
    y: 33.1359,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_d_10061_157235",
    x: 325.234,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_d_10061_157235",
    x: 337.234,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_d_10061_157235",
    x: 349.234,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_d_10061_157235",
    x: 361.234,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_d_10061_157235",
    x: 373.234,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.282353 0 0 0 0 0.6 0 0 0 0 0.921569 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_d_10061_157235",
    x: 385.234,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_d_10061_157235",
    x: 397.234,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_d_10061_157235",
    x: 409.234,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_d_10061_157235",
    x: 421.234,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988235 0 0 0 0 0.988235 0 0 0 0 0.992157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_d_10061_157235",
    x: 433.234,
    y: 51.8039,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_d_10061_157235",
    x: 313.234,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_d_10061_157235",
    x: 325.234,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.2 0 0 0 0 0.360784 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_d_10061_157235",
    x: 337.234,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_d_10061_157235",
    x: 349.234,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_d_10061_157235",
    x: 361.234,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_d_10061_157235",
    x: 373.234,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_d_10061_157235",
    x: 385.234,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.701961 0 0 0 0 0.941176 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_d_10061_157235",
    x: 397.234,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_d_10061_157235",
    x: 409.234,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_d_10061_157235",
    x: 421.234,
    y: 70.468,
    width: 9.06797,
    height: 9.06797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.33333,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10061_157235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10061_157235",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10061_157235",
    x1: 190.017,
    y1: 113.525,
    x2: 292.092,
    y2: -56.7607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3154,
    stopColor: "#8618FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#851CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3984,
    stopColor: "#8228F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#7D3CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#7658F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5222,
    stopColor: "#6D7CEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5628,
    stopColor: "#62A7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#5BC5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10061_157235",
    x1: 171.071,
    y1: 58.7312,
    x2: 252.807,
    y2: 58.7312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67B3F2",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1486,
    stopColor: "#67B0F2",
    stopOpacity: 0.9212
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2669,
    stopColor: "#66A6F2",
    stopOpacity: 0.9381
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#6495F2",
    stopOpacity: 0.9534
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4764,
    stopColor: "#627DF3",
    stopOpacity: 0.9679
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5737,
    stopColor: "#605FF3",
    stopOpacity: 0.9818
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6665,
    stopColor: "#5C3AF4",
    stopOpacity: 0.9951
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7011,
    stopColor: "#5B2AF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10061_157235",
    x1: 185.434,
    y1: 28.4342,
    x2: 210.367,
    y2: 28.4342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C45F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6793,
    stopColor: "#67B3F2",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10061_157235",
    x1: 174.195,
    y1: 31.5885,
    x2: 201.524,
    y2: 31.5885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#6C45F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7729,
    stopColor: "#67B3F2",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10061_157235",
    x1: 236.375,
    y1: 74.0297,
    x2: 258.921,
    y2: 74.0297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67B3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4566,
    stopColor: "#6A6CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7003,
    stopColor: "#6C45F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10061_157235",
    x1: 254.179,
    y1: 68.8238,
    x2: 288.076,
    y2: 68.8238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67B3F2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#67B0F2",
    stopOpacity: 0.616
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#68A6F2",
    stopOpacity: 0.7083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3327,
    stopColor: "#6895F2",
    stopOpacity: 0.7925
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#697DF2",
    stopOpacity: 0.8718
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5085,
    stopColor: "#6B5FF3",
    stopOpacity: 0.947
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5688,
    stopColor: "#6C45F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10061_157235",
    x1: 237.305,
    y1: 46.8104,
    x2: 288.957,
    y2: 46.8104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#67B3F2",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2591,
    stopColor: "#67B0F2",
    stopOpacity: 0.3088
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3673,
    stopColor: "#68A6F2",
    stopOpacity: 0.4749
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#6895F2",
    stopOpacity: 0.6265
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5589,
    stopColor: "#697DF2",
    stopOpacity: 0.7692
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6471,
    stopColor: "#6B5FF3",
    stopOpacity: 0.9046
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7092,
    stopColor: "#6C45F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10061_157235",
    x1: 209.084,
    y1: 29.6421,
    x2: 187.709,
    y2: 17.3011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6788,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10061_157235",
    x1: 175.586,
    y1: 32.615,
    x2: 194.997,
    y2: 32.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5164,
    stopColor: "white",
    stopOpacity: 0.954
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5688,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10061_157235",
    x1: 242.297,
    y1: 39.3158,
    x2: 272.896,
    y2: 39.3158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6366,
    stopColor: "white",
    stopOpacity: 0.5368
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7011,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10061_157235",
    x1: 250.789,
    y1: 77.0686,
    x2: 258.969,
    y2: 77.0686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8221,
    stopColor: "white",
    stopOpacity: 0.6928
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9493,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10061_157235",
    x1: 246.977,
    y1: 50.386,
    x2: 287.134,
    y2: 50.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A32BD",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5551,
    stopColor: "#5A37BE",
    stopOpacity: 0.5547
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6788,
    stopColor: "#5A39BF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10061_157235",
    x1: 252.279,
    y1: 22.2765,
    x2: 258.155,
    y2: 28.0813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A32BD",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5551,
    stopColor: "#5A37BE",
    stopOpacity: 0.5547
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6788,
    stopColor: "#5A39BF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10061_157235",
    x1: 237.258,
    y1: 88.0217,
    x2: 250.514,
    y2: 88.0217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67B3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4566,
    stopColor: "#6A6CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7003,
    stopColor: "#6C45F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10061_157235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.203,
    height: 110.998,
    fill: "white",
    transform: "translate(162.898 0.835938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLogo);
export default __webpack_public_path__ + "static/media/authLogo.3e01c553d8da12d5558a52e43560c611.svg";
export { ForwardRef as ReactComponent };